import axios from 'axios'
import { MessageBox } from 'element-ui'
import { startLoad,endLoad } from '@/utils/loading'
import { baseURL } from '@/utils/confing'

const ajax = axios.create({
    //baseURL:'http://manage.julicy.com/jlcy'	,    //'http://192.168.3.206:8080/jlcy',           //process.env.VUE_APP_BASICS,
    baseURL:baseURL,
    withCredentials:true
    //timeout:45
})


//请求拦截
//let load;
ajax.interceptors.request.use(config => {
    // config.cancelToken = new axios.CancelToken(function (c) {
    //     store.commit('cancelToken',c)
    // });
    startLoad();
    return config;
},err => {
    //load.close();
    endLoad();
    MessageBox.alert('加载超时',{
        type: 'warning',
    });
    return Promise.reject(err);
})

//响应拦截
ajax.interceptors.response.use(rps => {
    //load.close();
    endLoad();
    const { data } = rps;
    // if(status == '404'){
    //     alert(404)
    //     //return router.push('/404')
    // }
    if(data.code != 200){
        MessageBox.alert('业务请求失败',{
            type: 'warning',
        });
        return Promise.reject();
    }
    return data.result;
},err => {
    //load.close();
    endLoad();
    MessageBox.alert(err,{
        type: 'warning',
    });
    return Promise.reject(err);
});

export default ajax;